import Axios from 'axios'

const axios = Axios.create({
    baseURL:'//dct-user-auth.herokuapp.com'
})

export default axios